import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import eyeIconShow from '../../../assets/eye-icon-show.svg';
import eyeIconHide from '../../../assets/eye-icon-hide.svg';
function CustomInput({ id, label, placeholder, className, loading, type, isPassword, error, workorder, customIconObject,  ...rest }) {
    const [focused, setFocused] = useState(false);
    const [disabledClass, setDisabledClass] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    customIconObject = customIconObject || {};

    const onFocus = () => {
        setFocused('focused');
    };

    const onBlur = () => {
        setFocused('');
    };

    useEffect(() => {
        if (loading) {
            setDisabledClass('disabled');
        } else {
            setDisabledClass('');
        }
    }, [loading]);

    const setType = showPassword ? 'text' : 'password';

    const input = (
        <input
            className={`form-control ${error ? 'error' : ''} ${className}`}
            {...rest}
            placeholder={placeholder}
            aria-describedby={id}
            aria-label={placeholder}
            disabled={loading}
            onFocus={onFocus}
            onBlur={onBlur}
            type={isPassword ? setType : type}
        />
    );

    if(workorder){
        return input;
    }

    return (
        <div className={'custom-input ' + disabledClass}>
            <Form.Label htmlFor={id} className={focused}>
                {label}
            </Form.Label>
            <div className='input-container'>
                {input}
                {
                    !!error && <div className='invalid-feedback'>{error}</div>
                }
                {isPassword &&
                    <span onClick={() => setShowPassword((prevState) => !prevState)}>
                        {!showPassword ?
                            <img src={eyeIconShow} alt='password show icon' /> :
                            <img src={eyeIconHide} alt='password hide icon' />}
                    </span>}
                {customIconObject.showCustomIcon &&
                    <span>
                        <img src={customIconObject.source} alt={`custom-icon-${customIconObject.name}`} />
                    </span>
                }

            </div>
        </div>
    );
}

CustomInput.defaultProps = {
    label: 'Input Label',
    placeholder: '',
    className: '',
    loading: false,
};

export default CustomInput;
